import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const BodyGridContainer = styled(Grid)`
    top: 253px;
    left: 277px;
    width: 810px;
    // height: 145px;
    // padding-top: 15px;
    // padding-left: 20px;
    // padding-right: 10px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    margin-top: 5px;
    margin-bottom: 5px;
    opacity: 1;
    display: flex;
    font-size: 13px;
    ${media.mobileDevice`
    top: 253px;
    left: 277px;
    width: 358px;
    // height: 300px;
    // padding-top: 15px;
    // padding-left: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    display: flex;
    margin-top: 0px;
    margin-bottom: 10px;
    opacity: 1;
    `}
`;

export const AccountNameGrid = styled(Grid)`
    top: 266px;
    left: 491px;
    width: 185px;
    text-align: left;
    font-size: 13px;
    letter-spacing: -0.11px;
    color: #000000;
    opacity: 1;
    padding: ${(props) =>
        props.shipToAddressEdit ? '15px 20px 10px 20px' : '15px 20px'};

    ${media.mobileDevice`    
        // padding-left: 1px;
        margin-bottom: -20px !important;
`}
`;

export const AddressGrid = styled(Grid)`
    top: 266px;
    left: 692px;
    width: 106px;
    // height: 21px;
    text-align: left;
    letter-spacing: -0.1px;
    color: #140f4b;
    opacity: 1;
    padding: ${(props) =>
        props.shipToAddressEdit ? '15px 20px 10px 20px' : '15px 20px'};
    ${media.mobileDevice`    
    // padding-left: 1px;
    padding-bottom: 5px;
    margin-top: 20px; 
`}
`;

export const OrderDetailTabBodyContainer = styled.div`
    flex-grow: 1;
    overflow-y: scroll;
    margin-top: 5px;
    padding-right: 0px;
    box-sizing: border-box;
    padding-bottom: 55px;
    position: relative;
    &::-webkit-scrollbar {
        display: inline-flex;
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
        height: 12rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    ${media.mobileDevice`
        &::-webkit-scrollbar {
            display: none;
        }
        padding-bottom: 110px;
        padding-right: 0;
    `}
`;

export const OrderDetailTabBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 99%;
    margin: 0 auto;
`;

export const Footer = styled.div`
    width: 100%;
    height: 60px;
`;

export const HeaderOrderDefaultTextGrid = styled(Grid)`
    top: 210px;
    left: 909px;
    // width: 89px;
    // height: 22px;
    // padding-left: 25px;
    // padding-top: 15px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #3c3c3c;
    opacity: 0.7;
    text-align: left;
    padding: 15px 20px;
    ${media.mobileDevice`
        display: none;
        `};
`;

export const HeaderNameTextGrid = styled(Grid)`
    top: 209px;
    left: 298px;
    // width: 89px;
    // height: 22px;
    opacity: 0.7;
    font-family: 'AvenirNextWorld Demi';
    // padding-top: 13.95px;
    // padding-left: 21px;
    letter-spacing: 0px;
    color: #3c3c3c;
    text-align: left;
    padding: 15px 20px;
    ${media.mobileDevice`
        display: none;
    `};
`;

export const HeaderGridContainer = styled(Grid)`
    top: 197px;
    left: 277px;
    // width: 810px;
    // height: 48px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    font-size: 13px;
    position: sticky;
    top: 0;
    margin-top:12px;
    ${media.mobileDevice`
    display:none !important;
    `};
`;

export const HeaderAddressTextGrid = styled(Grid)`
    top: 209px;
    left: 597px;
    // width: 49px;
    // height: 22px;
    // padding-top: 13.95px;
    // padding-left: 13px;
    opacity: 1;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #3c3c3c;
    opacity: 0.7;
    text-align: left;
    padding: 15px 20px;
    ${media.mobileDevice`
        display: none;
    `};
`;

export const AccountName = styled.div`
    top: 270px;
    left: 298px;
    // width: 245px;
    height: auto;
    text-align: left;
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.11px;
    color: #140f4b;
    opacity: 1;
`;

export const AccountNumber = styled.div`
    top: 296px;
    left: 297px;
    // width: 160px;
    // height: 24px;
    text-align: left;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.11px;
    color: #140f4b;
    opacity: 1;
    ${media.mobileDevice`
    // margin-bottom:-8px;`};
`;

export const AccountDefaultDesktop = styled.div`
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    padding-top: 22.5px;
    color: #140f4b;
    opacity: 1;
    display: inline-flex;
    flex-direction: column;
    ${media.mobileDevice`
    display:none;`};
`;
export const TissueAndNonTissueCont = styled.div`
    display: flex;
    width: 55px;
    justify-content: space-between;
`;
export const AccountDefaultMobile = styled.div`
    display: none;
    ${media.mobileDevice`
    display: inline-flex;
    flex-direction: column;
    padding-top: 11px;
`};
`;

export const Address = styled.div`
    top: 268px;
    left: 570px;
    // width: 200px;
    // height: 62px;
    text-align: left;
    font-size: 13px;
    line-height: 20px;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: -0.1px;
    color: #000000;
    opacity: 1;
`;

export const OrderDefaultsGrid = styled(Grid)`
    display: inline-grid;
    flex-direction: column;
    // padding-top: 5px;
    // padding-left: 27px;
    margin-top: 10px;
    padding: ${(props) =>
        props.shipToAddressEdit ? '15px 20px 10px 20px' : '15px 20px'};
    ${media.mobileDevice`
    display: inline-block;
// padding-top: 45px;
// padding-left: 0px;`};
`;

export const Od = styled.div`
    display: none;
    ${media.mobileDevice`
font-family:'AvenirNextWorld Demi';
display: flex;`}
`;

export const OrderContent = styled.div`
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 18px;
    ${media.mobileDevice`
display: flex;
flex-direction: row;
padding-top: 2px;
margin-bottom: 0px;
justify-content: space-between;`}
`;

export const OnEditCheckbox = styled.div`
    display: inline-block;
    color: #555555;
    border: 1px solid !important;
`;

export const CustomCheckbox = styled.div`
    &.p-checkbox .p-checkbox-box {
        border: 2px solid ${(props) => (props.disabled ? '#8D8D8D' : '#555555')} !important;
        background: #ffffff;
        width: ${(props) => (props.width ? props.width : '20px')};
        height: ${(props) => (props.height ? props.height : '20px')};
        box-shadow: none !important;
        background-color: ${(props) => props.disabled && '#00000029'};
    }
`;
